import React from 'react';
import './EmptyState.css';

const EmptyState = ({ tabName }) => {
  const getEmptyMessage = (tab) => {
    return {
      title: 'هیچ صرافی‌ای یافت نشد',
      description: 'برای این ارز دیجیتال هیچ صرافی‌ای یافت نشد. لطفاً ارز دیگری را امتحان کنید.',
      icon: '💱'
    };
  };

  const emptyData = getEmptyMessage(tabName);

  return (
    <section className="empty-state" aria-labelledby="empty-state-title">
      <div className="empty-state-content">
        <div className="empty-state-icon" aria-hidden="true">
          {emptyData.icon}
        </div>
        <h2 className="empty-state-title" id="empty-state-title">
          {emptyData.title}
        </h2>
        <p className="empty-state-description">
          {emptyData.description}
        </p>
        <div className="empty-state-actions">
          <button className="refresh-button" onClick={() => window.location.reload()}>
            <svg aria-hidden="true" className="refresh-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23,4 23,10 17,10"></polyline>
              <polyline points="1,20 1,14 7,14"></polyline>
              <path d="M20.49,9A9,9,0,0,0,5.64,5.64L1,10m22,4L18.36,18.36A9,9,0,0,1,3.51,15"></path>
            </svg>
            تلاش مجدد
          </button>
        </div>
      </div>
    </section>
  );
};

export default EmptyState;
